import React from 'react';
import { ResultsStep } from './ResultsStep';
export function CombinedResultsStep({
  formData
}) {
  return <div className="space-y-6" data-id="element-123">
      <ResultsStep formData={formData} data-id="element-124" />
    </div>;
}